// User / provider display helpers.
//
// formatProviderName(provider) → "Last First, Credentials" style label
// used in every provider dropdown, picker, and badge across the app.
// Falls back gracefully when full_name is missing (composes from
// first_name + last_name) and omits the credentials suffix when the
// provider record has no credentials field set.
//
// Centralized here (Feb 2026) so the same conventions are enforced
// everywhere without inline ternaries duplicated across 15+ sites.

export function formatProviderName(provider) {
  if (!provider) return '';
  const name =
    provider.full_name ||
    `${provider.first_name || ''} ${provider.last_name || ''}`.trim() ||
    provider.name ||
    provider.email ||
    '';
  const creds = (provider.credentials || '').trim();
  if (creds) return `${name}, ${creds}`;
  return name;
}
